import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';

import { SearchRequestModel } from '~app/models/requests/search-request.model';
import { HelpTopicListModel } from '~app/models/responses/help-topic-list.model';
import { TreeDataSelectionConfig } from '~components/form/tree-autocomplete/models/tree-data-selection.config';
import { HelpSubTopicsStore } from './stores/help-sub-topics.store';
import { HelpTopicsStore } from './stores/help-topics.store';

export const generateHelpTopicConfig = (
    helpTopicsStore: HelpTopicsStore,
    helpSubTopicsStore: HelpSubTopicsStore
): TreeDataSelectionConfig<HelpTopicListModel> =>
    new TreeDataSelectionConfig({
        selectionDialogTitleKey: 'HelpTopics.EntityName',
        deepestLevel: 1,
        getNodeTitle: (group: HelpTopicListModel) => group.title,
        search: (searchText: string) => {
            const request = new SearchRequestModel({ searchText });

            return helpTopicsStore.search(request).pipe(map(response => response.value?.records ?? []));
        },

        loadRootItems: () => helpTopicsStore.getHelpTopics().pipe(map(response => response.value ?? [])),
        loadChildren: parentId => helpSubTopicsStore.getByHelpTopicId(parentId).pipe(map(response => response.value ?? [])),

        getNodeParent: node => node.parentNode,
        hasNodeChildren: node => node.hasChildren,

        store: helpTopicsStore
    });

@Injectable({
    providedIn: 'root'
})
export class TreeAutocompleteConfigsService {
    get helpTopicConfig(): TreeDataSelectionConfig<HelpTopicListModel> {
        return generateHelpTopicConfig(this.helpTopicsStore, this.helpSubTopicsStore);
    }

    private readonly helpTopicsStore = inject(HelpTopicsStore);
    private readonly helpSubTopicsStore = inject(HelpSubTopicsStore);
}
